import { Result } from "@/shared/feedback/result";
import { useTranslations } from "use-intl";
import { SignStatusIcon } from "@/modules/signing/shared/ui/sign-status-icon/sign-status-icon";
import { CheckCircleFilled } from "@ant-design/icons";
import { usePalette } from "@/shared/theme";
import Text from "@/shared/typography/text";

export function StatusSigned() {
  const t = useTranslations("Common");
  const palette = usePalette();

  return (
    <Result
      icon={
        <div className={"flex justify-center"}>
          <SignStatusIcon
            icon={<CheckCircleFilled />}
            iconColor={palette.success[6]}
            iconBackgroundColor={palette.success[1]}
            iconSecondaryBackgroundColor={palette.success[0]}
          />
        </div>
      }
      title={
        <Text as={"span"} medium type={"headline1"}>
          {t("SIGN_STATUS_SIGNED_TITLE")}
        </Text>
      }
      subTitle={
        <Text as={"span"} type={"body1"} color={"secondary"}>
          {t("SIGN_STATUS_SIGNER_SUBTITLE")}
        </Text>
      }
    />
  );
}
